import script from "./CheckboxGroupField.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxGroupField.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxGroupField.vue?vue&type=style&index=0&id=394252e9&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394252e9"]])

export default __exports__